<!--
    # 新首页
    # cnxjk 2022/07/22
 -->
<template>
  <div>
    <div>
      <!-- <el-card> -->
        <!-- 第一行，保安总数、当前在岗人数、服务单位数。 -->
        <el-row type="flex" justify="space-between">
          <el-col :span="7">
            <el-card :body-style="{ padding: '10px' }">
              <el-row type="flex" justify="center">
                <el-col :span="5">
                  <el-image style="width: 65px; height: 65px" :src="require('@/static/home/icn_1.png')" fit="fill"></el-image>
                </el-col>
                <el-col :span="10">
                  <span class="row01-col-span-value">3470人</span>
                  <br />
                  <span class="row01-col-span-name">报案总数</span>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="7">
            <el-card :body-style="{ padding: '10px' }">
              <el-row type="flex" justify="center">
                <el-col :span="5">
                  <el-image style="width: 65px; height: 65px" :src="require('@/static/home/icn_2.png')" fit="fill"></el-image>
                </el-col>
                <el-col :span="10">
                  <span class="row01-col-span-value">3470人</span>
                  <br />
                  <span class="row01-col-span-name">在岗人数</span>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="7">
            <el-card :body-style="{ padding: '10px' }">
              <el-row type="flex" justify="center">
                <el-col :span="5">
                  <el-image style="width: 65px; height: 65px" :src="require('@/static/home/icn_3.png')" fit="fill"></el-image>
                </el-col>
                <el-col :span="10">
                  <span class="row01-col-span-value">3470人</span>
                  <br />
                  <span class="row01-col-span-name">服务单位</span>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="2">
            <el-card class="row01-col04" :body-style="{ padding: '10px' }">
              <el-row type="flex" justify="center">
                <el-col :span="24">
                  <el-image style="width: 65px; height: 65px" :src="require('@/static/home/icn_4.png')" fit="fill"></el-image>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <!-- 第二行，男女比例统计、公告栏、待办事项。 -->
        <el-row type="flex" justify="space-between" style="margin-top: 10px">
          <el-col :span="18">
            <el-card :body-style="{ padding: '5px' }">
              <el-row type="flex" align="middle">
                <el-col :span="4">
                  <span style="font-size: 16px;font-weight: bold">保安综合信息统计</span>
                </el-col>
              </el-row>

              <el-divider></el-divider>
              <el-row type="flex" justify="space-between">
                <el-col :span="5">
                  <el-row style="background-image: linear-gradient(to bottom, rgba(78,157,251,1), rgba(181,214,253,1)); padding: 1%;" type="flex" align="middle">
                    <el-col :span="4" style="margin-left: 5px">
                      <el-image style="width: 22px; height: 22px" :src="require('@/static/home/icn_10.png')"></el-image>
                    </el-col>
                    <el-col :span="18" style="font-size: 15px;color: white">
                      <div>在职 3166人</div>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" style="margin-top: 10px">
                    <el-col :span="4" style="margin-left: 5px;background-color:#C2D8FB;">
                      <el-image style="width: 22px; height: 22px" :src="require('@/static/home/icn_11.png')"></el-image>
                    </el-col>
                    <el-col :span="18">
                      <span style="font-size: 15px;">退工</span>
                      <span style="font-size: 16px;color: #54a0fb">374人</span>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" style="margin-top: 10px">
                    <el-col :span="4" style="margin-left: 5px;background-color:#C2D8FB;">
                      <el-image style="width: 22px; height: 22px" :src="require('@/static/home/icn_12.png')"></el-image>
                    </el-col>
                    <el-col :span="18">
                      <span style="font-size: 15px;">退休</span>
                      <span style="font-size: 16px;color: #54a0fb">3166人</span>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" style="margin-top: 10px">
                    <el-col :span="4" style="margin-left: 5px;background-color:#C2D8FB;">
                      <el-image style="width: 22px; height: 22px" :src="require('@/static/home/icn_13.png')"></el-image>
                    </el-col>
                    <el-col :span="18">
                      <span style="font-size: 15px;">外借</span>
                      <span style="font-size: 16px;color: #54a0fb">3166人</span>
                    </el-col>
                  </el-row>
                  <!--                <el-row>-->
                  <!--                  <span>退休 3166人</span>-->
                  <!--                </el-row>-->
                  <!--                <el-row>-->
                  <!--                  <span>外借 3166人</span>-->
                  <!--                </el-row>-->
                </el-col>
                <el-col :span="6">
                  <echart-01></echart-01>
                </el-col>
                <el-col :span="6">
                  <echart-02></echart-02>
                </el-col>
                <el-col :span="4">
                  <el-card shadow="never" class="box-card">
                    <div slot="header" style="font-size: 15px">
                      <span>本月之星</span>
                    </div>
                    <div class="text item" style="text-align: center">
                      某某陈
                    </div>
                    <div class="text item" style="text-align: center">
                      某某陈
                    </div>
                    <div class="text item" style="text-align: center">
                      某某陈
                    </div>
                    <div class="text item" style="text-align: center">
                      某某陈
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row type="flex" justify="space-between">
                <el-col :span="19"></el-col>
                <el-col :span="14"></el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card :body-style="{ padding: '10px' }">
              <el-row type="flex" align="middle">
                <el-col :span="6">
                  <span style="font-size: 16px;font-weight: bold">公告栏</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col span="24">
                  <el-carousel :interval="5000" arrow="always">
                    <el-carousel-item v-for="item in 4" :key="item">
                      <el-image style="width: 100%;height:100%;padding: 10px" :src="require('@/static/home/icn_14.png')"></el-image>
                    </el-carousel-item>
                  </el-carousel>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <!--                    <el-row type="flex" align="middle">-->
          <!--                        <el-col :span="4">-->
          <!--                            <span style="font-size: 16px;">年龄构成(岁)</span>-->
          <!--                        </el-col>-->
          <!--                    </el-row>-->
          <el-row>
            <el-col :span="18">
              <el-card :body-style="{ padding: '10px' }">
                <el-col :span="8">
                  <echart03></echart03>
                </el-col>
                <el-col :span="16">
                  <echart04></echart04>
                </el-col>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="item">待办事项</span>
                </div>
                <el-row class="text" id="tips">
                  <el-alert type="warning" title="" style="margin-bottom: 10px" class="new" :closable="false">
                    <template slot="title">
                      有1名人员合同即将到期
                    </template>
                    <template slot="">
                      <el-link style="font-size: 13px" type="warning">更多></el-link>
                    </template>
                  </el-alert>
                  <el-alert type="warning" title="" style="margin-bottom: 10px" class="new" :closable="false">
                    <template slot="title">
                      有1名人员合同即将到期
                    </template>
                    <template slot="">
                      <el-link style="font-size: 13px" type="warning">更多></el-link>
                    </template>
                  </el-alert>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
        </el-row>
      <!-- </el-card> -->
    </div>
    <div>
      <el-row>
        <el-row>
          <el-col :span="18">
            <el-card :body-style="{ padding: '10px' }">
              <el-row type="flex" align="middle">
                <el-col :span="4">
                  <span style="font-size: 16px;font-weight: bold">近十年服务单位趋势</span>
                </el-col>
              </el-row>
              <el-row style="border: solid red">
                <el-col :span="4">
                  <el-row type="flex" align="middle" style="margin: 5px;background-color: #fff3ef">
                    <el-col :span="10">
                      <el-image style="width: 50px;height:50px;padding: 10px" :src="require('@/static/home/icn_9.png')"></el-image>
                    </el-col>
                    <el-col :span="14">
                      <el-row>
                        <el-col :span="24">
                          <span style="font-size: 20px">6500</span>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <span style="font-size: 10px">合同总额(万元)</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" style="margin: 5px;background-color: #e4f2fe">
                    <el-col :span="10">
                      <el-image style="width: 50px;height:50px;padding: 10px" :src="require('@/static/home/icn_6.png')"></el-image>
                    </el-col>
                    <el-col :span="14">
                      <el-row>
                        <el-col :span="24">
                          <span style="font-size: 20px">450</span>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <span style="font-size: 10px">数据展示(家)</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row type="flex" align="middle" style="margin: 5px;background-color: #e5eafb">
                    <el-col :span="10">
                      <el-image style="width: 50px;height:50px;padding: 10px" :src="require('@/static/home/icn_7.png')"></el-image>
                    </el-col>
                    <el-col :span="14">
                      <el-row>
                        <el-col :span="24">
                          <span style="font-size: 20px">6500</span>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <span style="font-size: 10px">应收未收(万元)</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="13" style="border: solid red">
                  <echart05></echart05>
                </el-col>
                <el-col :span="6">
                  <el-row type="flex">
                    <el-col :span="24" :pull="6">
                      <span style="font-size: 12px;">问卷调查情况</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <echart06></echart06>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card">
              <el-row type="flex">
                <el-col :span="24" :pull="6">
                  <span style="font-size: 16px;font-weight: bold">访客登记信息</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <echart07></echart07>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <div>
      <el-card style="padding: 10px">
        <el-row>
          <el-col :span="6"></el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-col :span="4" :pull="1">
            <span style="font-size: 16px;font-weight: bold">保安动态管理信息</span>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <echart08></echart08>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import echart01 from './common/echart01.vue'
import echart02 from './common/echart02.vue'
import echart03 from './common/echart03.vue'
import echart04 from './common/echart04.vue'
import echart05 from './common/echart05.vue'
import echart06 from './common/echart06.vue'
import echart07 from './common/echart07.vue'
import echart08 from './common/echart08.vue'
export default {
  components: { echart01, echart02, echart03, echart04, echart05, echart06, echart07, echart08 },
  mounted() {},
  methods: {}
}
</script>

<style>
.row01-col-span-value {
  color: #54a0fb;
  font-size: 18px;
}

.row01-col-span-name {
  font-size: 12px;
}

.row01-col04 {
  background-color: #54a0fb;
}

.el-input__inner {
  height: 25px;
}

/* .clearfix:after {
  clear: both;
} */
</style>
